// extracted by mini-css-extract-plugin
export default {"Card":"card_Card__CuZ7S"};